// extracted by mini-css-extract-plugin
export default {"btn":"GradientButton-module__[local]___dGtKw","inv":"GradientButton-module__[local]___ZPOZI"};